import { useSubscription } from "@/hooks/useSubscription";

const PRO_FEATURES_TIERS = ['pro', 'enterprise', 'debug', 'welcome'];

export function useFeatureAccess() {
  const { subscription, isLoading } = useSubscription();
  
  const tier = subscription?.tier || null;
  const hasProFeatures = tier !== null && PRO_FEATURES_TIERS.includes(tier);

  return {
    canUseSmartCategories: hasProFeatures,
    canUseSmartNotes: hasProFeatures,
    canUseFieldPresets: hasProFeatures,
    tier,
    isLoading,
  };
}
